/* istanbul ignore file */
__webpack_public_path__ = window.bonaPage_WebPackRootPath || __webpack_public_path__; // eslint-disable-line no-undef, camelcase